export const PLACEHOLDER_IMG_URL =
  'https://cdn.uppbeat.io/images/ub-track-placeholder.png';
